import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-0b8a779c.js';
import 'classnames';

var ChevronLeft = createSvgIcon(React__default.createElement("path", { clipRule: "evenodd", d: "M9.41427 12.0711L15.7782 5.70712L14.364 4.29291L6.58584 12.0711L14.364 19.8493L15.7782 18.435L9.41427 12.0711Z", fillRule: "evenodd" }), 'ChevronLeft');

export { ChevronLeft };
